import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found TechniaHQRobot" description="This TechniaHQRobot robotics page could not be found." path="/404" noindex />
      <section data-page-kind="not-found" className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-neutral-500">404</p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-neutral-950">Page not found</h1>
        <p className="mt-4 text-neutral-600">The page you are looking for does not exist. Start with the robotics taxonomy, sensors guide, or robotics topics map.</p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link to="/robot-types" className="rounded-full bg-blue-600 px-5 py-3 text-sm font-bold text-white">Robot Types</Link>
          <Link to="/robot-sensors" className="rounded-full border border-neutral-200 px-5 py-3 text-sm font-bold text-neutral-950">Sensors</Link>
          <Link to="/robotics-topics" className="rounded-full border border-neutral-200 px-5 py-3 text-sm font-bold text-neutral-950">Topics</Link>
        </div>
      </section>
    </>
  );
}